import { useState, useEffect, useRef } from 'react';

export const useTypewriter = (text: string, typingInterval = 6) => {
  const [displayedText, setDisplayedText] = useState('');
  const [isDone, setIsDone] = useState(false);
  const indexRef = useRef(0);
  const timeoutIdRef = useRef<NodeJS.Timeout | null>(null);
  const prevTextRef = useRef(''); // Initialize with empty string

  useEffect(() => {
    if (prevTextRef.current !== text) {
      prevTextRef.current = text;
      setDisplayedText('');
      indexRef.current = 0;

      const typeCharacter = () => {
        if (indexRef.current < text.length) {
          setDisplayedText(text.substring(0, indexRef.current + 1));
          indexRef.current += 1;
          timeoutIdRef.current = setTimeout(typeCharacter, typingInterval);
        } else {
          // Typing complete; clear the timeout
          if (timeoutIdRef.current) {
            clearTimeout(timeoutIdRef.current);
            timeoutIdRef.current = null;
            setIsDone(true);
          }
        }
      };

      typeCharacter(); // Start typing immediately
    }

    return () => {
      // // Cleanup timeout only if typing effect was started
      // if (didChange && timeoutIdRef.current) {
      //   console.log('didChange');
      //   clearTimeout(timeoutIdRef.current);
      //   timeoutIdRef.current = null;
      // }
    };
  }, [text, typingInterval]);

  return [displayedText, isDone];
};
